import * as Rollbar from "rollbar";
import { ErrorReporterArgumentType } from "../../domain/interfaces/error-reporter-argument-type";
import { IErrorReporter } from "../../domain/interfaces/error-reporter.interface";

export class RollbarErrorReporter implements IErrorReporter {

	private rollbar: Rollbar;

	constructor(rollbar: Rollbar) {
		this.rollbar = rollbar;
	}

	public critical(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.critical(...args);
	}

	public debug(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.debug(...args);
	}

	public error(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.error(...args);
	}

	public info(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.info(...args);
	}

	public log(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.log(...args);
	}

	public warn(...args: ErrorReporterArgumentType[]): void {
		this.rollbar.warn(...args);
	}

}
